import { IManagerSegmentComplete, IManagerSegmentVisibility } from './client';
import { MANAGER_SEGMENT_QUESTIONS } from './config';
import {
  ManagerSegment,
  ManagerSegmentAnswerValue,
  ManagerSegmentCompleteServer,
  ManagerSegmentVisibilityServer
} from './server';

export const normalizeManagerSegmentVisibility = (
  raw: ManagerSegmentVisibilityServer
): IManagerSegmentVisibility => ({
  showSegment: raw.show_segment
});

export const normalizeManagerSegmentComplete = (
  value: IManagerSegmentComplete
): ManagerSegmentCompleteServer => {
  const answersByQuestion = new Map(
    value.answers.map((answer) => [answer.question, answer.values])
  );
  const answers = MANAGER_SEGMENT_QUESTIONS[value.segment].map((definition) => {
    const selectedValues = new Set(
      answersByQuestion.get(definition.question) || []
    );

    return {
      question: definition.question,
      values: definition.values.filter((answerValue) =>
        selectedValues.has(answerValue)
      )
    };
  });
  const hasOtherAnswer = answers.some((answer) =>
    answer.values.includes(ManagerSegmentAnswerValue.other)
  );

  return {
    segment: value.segment,
    answers,
    segment_other_text:
      value.segment === ManagerSegment.other
        ? value.segmentOtherText?.trim() || null
        : null,
    task_other_text: hasOtherAnswer ? value.taskOtherText?.trim() || null : null
  };
};
